import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11779_24959",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }, [
      _createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11779_24959)" }, [
      _createElementVNode("path", {
        d: "M5 21V7H8.5V6.5C8.5 5.52817 8.84042 4.70192 9.52125 4.02125C10.2019 3.34042 11.0282 3 12 3C12.9718 3 13.7981 3.34042 14.4788 4.02125C15.1596 4.70192 15.5 5.52817 15.5 6.5V7H19V21H5ZM6 20H18V8H15.5H14.5H9.5H8.5H6V20ZM9.5 7H14.5V6.5C14.5 5.79617 14.2593 5.2035 13.778 4.722C13.2965 4.24067 12.7038 4 12 4C11.2962 4 10.7035 4.24067 10.222 4.722C9.74067 5.2035 9.5 5.79617 9.5 6.5V7Z",
        fill: "black"
      })
    ], -1)
  ])))
}
export default { render: render }